export type InformationRequestAction = {
  id: string;
  informationRequestId: string;
  actionType: number;
  subject: string;
  message: string;
  dueDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  actionAttachments: ActionAttachment[];
  status: true | false;
};

export enum ActionTypeCode {
  ReadDocument = "Read",
  UploadDocument = "Upload",
  SendMessage = "Respond",
}

export type ActionAttachment = {
  actionId: string;
  blobId: string;
  createdByUpn: string;
  createdByDisplayName: string;
  createdDate: string;
  fileName: string;
  contentType: string;
};

export type InformationRequestActionViewModel = Omit<
  InformationRequestAction,
  "actionAttachments"
> & {
  actionAttachments: (ActionAttachment & { id: string; isToDelete?: boolean })[];
  files: File[];
};
